// extracted by mini-css-extract-plugin
export default {"contact":"style_contact__cyO1h","card":"style_card__3vqih"};